import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-6 mb-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "col-md-12 m-10" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "border border-primary mb-10" }
const _hoisted_16 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "fs-4 text-white" }
const _hoisted_19 = { class: "col-md-4 text-center" }
const _hoisted_20 = { class: "p-6 bg-ecf3f2" }
const _hoisted_21 = { class: "d-block fw-medium text-black-emphasis fs-13 text-uppercase" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "d-flex float-end" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "accordion dark-accordion my-3 py-7",
  id: "magasin"
}
const _hoisted_26 = ["id"]
const _hoisted_27 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_28 = ["id", "aria-labelledby"]
const _hoisted_29 = { class: "accordion-body" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-10 mb-2" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "col-md-2" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "border border-primary mb-10" }
const _hoisted_36 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_37 = { class: "col-md-5" }
const _hoisted_38 = { class: "d-flex float-end" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "p-3" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "form-group mb-2" }
const _hoisted_43 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = { class: "form-group mb-2" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = { class: "form-group mb-2" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_52 = { class: "col-md-2 mb-2" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "col-md-12 mt-3" }
const _hoisted_55 = { class: "d-flex justify-content-start mb-4" }
const _hoisted_56 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Samp = _resolveComponent("Samp")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addSortie,
        "validation-schema": _ctx.sortieSchema,
        "keep-values": _ctx.valuess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1)),
                _createVNode(_component_Field, {
                  name: "dateSortie",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateSortie",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Récuperant "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "recuperant",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le récupérant"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "recuperant",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Bénéficiaire"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "beneficiaire",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le beneficiaire"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "beneficiaire",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Motif ", -1)),
                _createVNode(_component_Field, {
                  name: "motifSortie",
                  as: "textarea",
                  rows: "2",
                  placeholder: "Entrer les motifSorties",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_12), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "motifSortie",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h4", _hoisted_18, [
                        _createVNode(_component_Samp),
                        _cache[5] || (_cache[5] = _createTextVNode("Sortie par Magasin"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, " Montant total: " + _toDisplayString(_ctx.montantTotal), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          disabled: _ctx.isDisable,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRowMagasin()))
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode("Ajouter un magasin ")
                        ]), 10, _hoisted_24)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.magasins, (magasin, magasinIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "accordion-item accordion-wrapper",
                          key: magasinIndex
                        }, [
                          _createElementVNode("h2", {
                            class: "accordion-header",
                            id: `magasin${magasinIndex}`
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(`accordion-button bg-light-primary font-primary ${_ctx.magasins.length == magasinIndex + 1 ? '' : 'collapsed'}`),
                              type: "button",
                              "data-bs-toggle": "collapse",
                              "data-bs-target": `#collapse${magasinIndex}`,
                              "aria-expanded": `${_ctx.magasins.length == magasinIndex + 1 ? true : false}`,
                              "aria-controls": `collapse${magasinIndex}`
                            }, [
                              _createTextVNode(_toDisplayString(magasin.nomMagasin ? magasin.nomMagasin : `Magasin ${magasinIndex + 1}`) + " ", 1),
                              _cache[7] || (_cache[7] = _createElementVNode("i", {
                                class: "vue-feather vue-feather--chevron-down svg-color",
                                "data-name": "chevron-down",
                                "data-tags": "expand",
                                "data-type": "chevron-down"
                              }, [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  class: "feather feather-chevron-down vue-feather__content"
                                }, [
                                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                ])
                              ], -1))
                            ], 10, _hoisted_27)
                          ], 8, _hoisted_26),
                          _createElementVNode("div", {
                            class: _normalizeClass(`accordion-collapse collapse ${_ctx.magasins.length == magasinIndex + 1 ? 'show' : ''}`),
                            id: `collapse${magasinIndex}`,
                            "aria-labelledby": `magasin${magasinIndex}`,
                            "data-bs-parent": "#magasin",
                            style: {}
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_Multiselect, {
                                      options: _ctx.magasinOptions,
                                      searchable: true,
                                      "track-by": "label",
                                      label: "label",
                                      modelValue: magasin.magasin,
                                      "onUpdate:modelValue": ($event: any) => ((magasin.magasin) = $event),
                                      placeholder: "Sélectionner le magasin",
                                      onSelect: ($event: any) => (_ctx.selectMag(magasin.magasin, magasin))
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("button", {
                                    class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeRowMagasin(magasinIndex))
                                  }, _cache[8] || (_cache[8] = [
                                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                  ]), 8, _hoisted_34)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-7" }, [
                                    _createElementVNode("h5", { class: "fs-6 mx-1 text-white" }, "Ajouter les produits dans le magasin")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-success",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.addRowProduit(magasinIndex))
                                      }, _cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                                        _createTextVNode("Ajouter un produit ")
                                      ]), 8, _hoisted_39)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row mt-10" }, [
                                    _createElementVNode("div", { class: "col-md-4" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                        _createTextVNode(" Produit "),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ]),
                                    _createElementVNode("div", { class: "col-md-3" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                        _createTextVNode(" Prix"),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ]),
                                    _createElementVNode("div", { class: "col-md-3" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                        _createTextVNode(" Quantité"),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ]),
                                    _createElementVNode("div", { class: "col-md-2" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                                    ]),
                                    _createElementVNode("hr", { class: "mt-0" })
                                  ], -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(magasin.produits, (produit, produitIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "row gy-0",
                                      key: produitIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _createVNode(_component_Multiselect, {
                                            options: _ctx.produitOptions,
                                            searchable: true,
                                            "track-by": "label",
                                            label: "label",
                                            modelValue: produit.produit,
                                            "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                                            placeholder: "Sélectionner le produit",
                                            onSelect: ($event: any) => ( _ctx.selectProd(produit.produit, produit))
                                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                                          (_ctx.validateRowProduit(produit.produit))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Le produit est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => ((produit.prixUnitaire) = $event),
                                            type: "number",
                                            class: "form-control shadow-none fs-md-15 text-black bg-light",
                                            placeholder: "Prix auto"
                                          }, null, 8, _hoisted_46), [
                                            [_vModelText, produit.prixUnitaire]
                                          ]),
                                          (_ctx.validateRowProduit(produit.prixUnitaire))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Le prix unitaire est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("div", _hoisted_49, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qtite) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.qtite)
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                          : 'form-control shadow-none fs-md-15 text-black '),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_50), [
                                            [_vModelText, produit.qtite]
                                          ]),
                                          (_ctx.validateRowProduit(produit.qtite))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, " La quantité est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("button", {
                                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.removeRowProduit(magasinIndex, produitIndex))
                                        }, _cache[11] || (_cache[11] = [
                                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                        ]), 8, _hoisted_53)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ], 10, _hoisted_28)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-5", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Ajouter une sortie ", 10, _hoisted_56),
                _createVNode(_component_router_link, {
                  to: "/sorties/liste-sorties",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "keep-values"])
    ])
  ]))
}